import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Upload({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Upload.Outline {...props} /> : <Upload.Solid {...props} />;
}

Upload.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M8.57469 4.58973C8.28245 4.88328 8.28351 5.35815 8.57705 5.65039C8.8706 5.94263 9.34547 5.94157 9.63771 5.64803L11.2715 4.00697V14.2314C11.2715 14.6456 11.6073 14.9814 12.0215 14.9814C12.4357 14.9814 12.7715 14.6456 12.7715 14.2314V4.0071L14.4058 5.64812C14.6981 5.94162 15.1729 5.94259 15.4664 5.6503C15.7599 5.35801 15.7609 4.88314 15.4686 4.58964L12.5723 1.68139C12.4368 1.53482 12.2435 1.44245 12.0286 1.44046L12.0215 1.44043C11.809 1.44043 11.6171 1.52881 11.4806 1.67082L8.57469 4.58973Z"
          fill="currentColor"
        />
        <path
          d="M6.45648 21.978C4.0074 21.978 2.02148 19.9924 2.02148 17.544V12.669C2.02148 10.2198 4.00727 8.23401 6.45648 8.23401H7.38948C7.8037 8.23401 8.13948 8.5698 8.13948 8.98401C8.13948 9.39822 7.8037 9.73401 7.38948 9.73401H6.45648C4.8357 9.73401 3.52148 11.0482 3.52148 12.669V17.544C3.52148 19.1637 4.83557 20.478 6.45648 20.478H17.5865C19.2074 20.478 20.5215 19.1637 20.5215 17.544V12.659C20.5215 11.044 19.212 9.73401 17.5975 9.73401H16.6545C16.2403 9.73401 15.9045 9.39822 15.9045 8.98401C15.9045 8.5698 16.2403 8.23401 16.6545 8.23401H17.5975C20.041 8.23401 22.0215 10.2161 22.0215 12.659V17.544C22.0215 19.9924 20.0356 21.978 17.5865 21.978H6.45648Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Upload.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
